import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import PreviousIcon from 'grommet/components/icons/base/Previous';
import NextIcon from 'grommet/components/icons/base/Next';
import CloseIcon from 'grommet/components/icons/base/Close';
import NotesIcon from 'grommet/components/icons/base/CircleInformation';
import LinksIcon from 'grommet/components/icons/base/LinkTop';

class Buttons{
  constructor(icons={}){
    /* Buttons */
    class Close extends React.Component {
      render(){
        const classNames = cx({
          'close-button': true
        })
        let buttonProps = {
          className: classNames,
          onClick: (e) => { e.preventDefault(); this.props.onClick(e) },
          title: "Links"
        }
        if(icons.close && icons.close.length>0){
          buttonProps.html = icons.close
        }
        else{
          buttonProps.icon = CloseIcon;
        }
        return (<CustomButton {...buttonProps} />) ;
      }
    }
    class Links extends React.Component{
      render(){
        const classNames = cx({
          'links-link': true,
          'active': this.props.isActive
        })
        let buttonProps = {
          className: classNames,
          onClick: (e) => { e.preventDefault(); this.props.onClick(e) },
          title: "Links"
        }
        if(icons.links && icons.links.length>0){
          buttonProps.html = icons.links
        }
        else{
          buttonProps.icon = LinksIcon;
        }
        return (<CustomButton {...buttonProps} />) ;
      }
    }
    class Notes extends React.Component{
      render(){
        const classNames = cx({
          'notes-link': true,
          'active': this.props.isActive
        })
        let buttonProps = {
          className: classNames,
          onClick: (e) => { e.preventDefault(); this.props.onClick(e) },
          title: "Notes"
        }
        if(icons.notes && icons.notes.length>0){
          buttonProps.html = icons.notes
        }
        else{
          buttonProps.icon = NotesIcon;
        }
        return (<CustomButton {...buttonProps} />) ;
      }
    }
    class PrevArrow extends React.Component {
      render(){
        const classNames = cx({
          'carousel-arrow': true,
          'previous-button': true
        })
        let buttonProps = {
          className: classNames,
          onClick: (e) => { e.preventDefault(); this.props.onClick(e) },
          title: "Previous"
        }
        if(icons.prevArrow && icons.prevArrow.length>0){
          buttonProps.html = icons.prevArrow;
        }
        else{
          buttonProps.icon = PreviousIcon;
        }
        return (<CustomButton {...buttonProps} />) ;
      }
    }

    class NextArrow extends React.Component {
      render(){
        const classNames = cx({
          'carousel-arrow': true,
          'next-button': true
        })
        let buttonProps = {
          className: classNames,
          onClick: (e) => { e.preventDefault(); this.props.onClick(e) },
          title: "Next"
        }
        if(icons.nextArrow && icons.nextArrow.length>0){
          buttonProps.html = icons.nextArrow;
        }
        else{
          buttonProps.icon = NextIcon;
        }
        return (<CustomButton {...buttonProps} />) ;
      }
    }

    class CustomButton extends React.Component {
      render() {
        if(this.props.icon==null && this.props.html.length==0){
          return false;
        }
        else if(this.props.html.length>0){
          const html = Utils.getDangerousHtml(this.props.html);
          return (
              <button onClick={this.props.onClick} className={this.props.className}>
                <span className="icon-container" dangerouslySetInnerHTML={html}></span>
              </button>
          );
        }
        else{
          return(
              <button onClick={this.props.onClick} className={this.props.className}>
                <span className="icon-container"><this.props.icon /></span>
              </button>
          )
        }

      }
    }
    CustomButton.propTypes={
        className: React.PropTypes.string,
        onClick: React.PropTypes.func,
        title: React.PropTypes.string,
        html: React.PropTypes.string,
        icon: React.PropTypes.func
    }
    CustomButton.defaultProps={
      title: "",
      html: "",
      icon: null
    }

    /* End Buttons */

    this.Close = Close;
    this.PrevArrow = PrevArrow;
    this.NextArrow = NextArrow;
    this.Notes = Notes;
    this.Links = Links;

  }

}

export default Buttons;


// WEBPACK FOOTER //
// ./src/app/carousel/buttons.jsx